//========gGoKwik-Cart-Slide-all-css=====//
(function() {
    function injectCSS() {
        const shadowContainer = document.querySelector("shadow-dom-container");
        if (!shadowContainer || !shadowContainer.shadowRoot) {
            setTimeout(injectCSS, 50);
            return;
        }
        
        const shadowRoot = shadowContainer.shadowRoot;
        if (shadowRoot.querySelector("#sidecart-css")) return;
        
        const style = document.createElement("style");
        style.id = "sidecart-css";
        style.textContent = `


.sidecart.svelte-1nlkjzs.svelte-1nlkjzs {
    width: 446px !important;
}
            .sidecart .side-cart-header { order: 1; }
            .sidecart .countdown-container { order: 2; }
            .sidecart .promotion-banner {  }
           .sidecart  .custom-brand-banner {order: 4;
}

            .sidecart .progress-container { order: 3; }
            .sidecart .top-section { order: 5; }
            .sidecart .sidecart-footer-wrapper { order: 6; }
            .sidecart { border-radius: 0 !important; }
            .sidecart {background: #ffffff !important;}
            .next-milestone-text.svelte-nuzrbq {
                 position: relative;
             }
             .side-cart-header.svelte-1cpywgq p.svelte-1cpywgq {
           font-weight: 400 !important;
            font-family: "PT Serif", serif !important;
               }
               .progress-container.svelte-nuzrbq .next-milestone-text.svelte-nuzrbq {
                margin-left: 45px !important;
                font-size: 16px !important;
                font-weight: 700 !important;
                    min-height: 28px !important;
                display: grid !important;
                align-items: center !important;
                    margin-bottom: 0 !important;
            }
.next-milestone-text.svelte-nuzrbq:before {
    content: '' !important;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Frame_120.svg?v=1776493675);
    width: 28px;
    height: 28px;
    position: absolute;
    left: -36px;
}
.sidecart .custom-brand-banner {
    background: #446F35 !important;
    border-radius: 0 0 15px 15px;
}
.item-list-wrapper.svelte-1k1ehgb {
    margin: 16px !important;
    margin-bottom: 0 !important;
}
.item-list-wrapper.svelte-1k1ehgb {
    border: 0 !important;
}
.product-tile-wrapper:not(.sku-enabled) {
    border: none !important;
    border-radius: 10px !important;
    margin-bottom: 16px !important;
    box-shadow: 0px 0px 4px 0px #00000040;
}
.progress-container.svelte-nuzrbq .container.svelte-nuzrbq {
    margin-top: 10px !important;
}
.custom-brand-banner img {
    width: 20px !important;
        height: auto !important;
}
.sidecart .custom-brand-banner {
    display: flex !important;
    justify-content: center;
    align-items: center !important;
}
.my-checkout-text {
    text-align: center;
    position: relative;
    color: #fff;
    background: #870A0A !important;
    padding: 8.5px !important;
    margin: auto;
    width: calc(100% - 40px);

}
.my-checkout-text:before {
    content: '';
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Group_17880.svg?v=1776500540);
    position: absolute;
    height: 40px;
    width: 10px;
    left: -5px;
    top: 0;
}
.my-checkout-text:after {
    content: '';
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Group_17880.svg?v=1776500540);
    position: absolute;
    height: 40px;
    width: 10px;
    right: -5px;
    top: 0;
}
.my-checkout-text span {
    position: relative;
    top: 1px;
}
.my-offer-text span {
    font-weight: 400 !important;
    font-family: "PT Serif", serif !important;
    font-size: 18px;
    color: #000 !important;
}

.my-offer-text {
    margin: 0 !important;
   padding: 14px 16px 8px !important;
}
.order-breakdown.svelte-yb4nuo {
    position: absolute !important;
    bottom: 0 !important;
}
.order-breakdown.svelte-yb4nuo {
    position: absolute !important;
    width: calc(100% - 20px);
    left: 10px;
    border: none !important;
    right: 0;
    box-shadow: 0px 0px 4px 0px #00000040;
    bottom: 118px !important;
        background: #fff !important;
            z-index: 99;
}
svg.iconify.iconify--tabler {
    display: none !important;
}
body .double-button.svelte-yb4nuo .gokwik-button-wrapper .total-amount.svelte-yb4nuo {
    flex-direction: column !important;
    max-width: 50% !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout.svelte-yb4nuo {
    width:55% !important;
}

.double-button.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    flex-direction: row !important;
}

.estimated-total-container.svelte-yb4nuo * {
    text-align: left !important;
}

.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .estimated-total-container.svelte-yb4nuo {
    margin-right: auto !important;
}
.double-button.svelte-yb4nuo .gokwik-button-wrapper .total-amount.svelte-yb4nuo {
    flex-direction: column !important;
    align-items: center !important;
    max-width: 45% !important;
}
.side-cart-header.svelte-1cpywgq.svelte-1cpywgq {
    padding: 10px 16px !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total.svelte-yb4nuo {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #9B5E34 !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo svg {
    min-width: 15px  !important;
    width: 15px  !important;
    height: 15px  !important;
    padding: 0 !important;
    flex-shrink: 0  !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo {
    gap: 0  !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo svg path{
       fill: #9B5E34 !important;
}
.item .item-price .compare-at-price {
    font-size: 11px !important;
    color: #999999 !important;
}
.item .item-price .discount-percentage {
    color: #FE7E42 !important;
    font-weight: 700 !important;
    font-size: 12px !important;
}
.item .item-price .final-price,  .item-price span {
    font-weight: 700 !important;
    font-size: 16px !important;
}
  .item .details .sidecart-product-title {
    font-size: 16px !important;
    font-weight: 700 !important;
}
.sidecart-footer.svelte-yb4nuo.svelte-yb4nuo {
    padding: 5px 16px !important;
} 
.ribbon.svelte-1wgo1p4 {
    background: #446F35 !important;
}
.ribbon.svelte-1wgo1p4::after {
    border-left: 5px solid #3d7139 !important;
}
.ribbon.svelte-1wgo1p4:before, .ribbon.svelte-1wgo1p4:after, .ribbon.svelte-1wgo1p4::before {
    background: #3d7139 !important;
}
.ribbon.svelte-1wgo1p4::before {
    border-right: 5px solid #3d7139 !important;
}
.offer-box.svelte-1uev9t0.svelte-1uev9t0 {
    padding-top: 16px !important;
    background: #F5F5F5 !important;
    gap: 20px !important;
}
.discount-input-area.svelte-hjytin input.svelte-hjytin {
    background: #f5f5f5 !important;
    width: 100% !important;

}
.view-offers-button.svelte-1uev9t0.svelte-1uev9t0 {
    background-color: #f5f5f5 !important;
    width: auto !important;
    padding: 0 !important;
}
    .view-notes-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
        margin: 0;
}
    svg.arrow-icon.iconify.iconify--mingcute path+path {
    fill: #9b5e34 !important;
}
    .offer-box.svelte-1uev9t0 span.svelte-1uev9t0:first-child {
    margin-right: 0 !important;
}
        .view-offers-button.svelte-1uev9t0 .offers-text.svelte-1uev9t0 {
    color: #9b5e34 !important;
}
.gokwik-checkout.svelte-yb4nuo button.svelte-yb4nuo {
    background: #9B5E34 !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout button .btn-content .btn-text.svelte-yb4nuo {
       display: block !important;
    position: relative;
    top: 2px;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout button .btn-content .btn-text.svelte-yb4nuo * {
   font-size:16px !important;
}
span.payment-icons.svelte-yb4nuo img {
    max-height: 24px !important;
}
.double-button.svelte-yb4nuo .gokwik-button-wrapper .gokwik-checkout button.svelte-yb4nuo {
    padding: 6px !important;
    height: 48px;
    padding-left: 15px !important;
    padding-right: 15px !important;
    border-radius: 35px;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    align-items:center !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    padding: 10px 0  !important;
    align-items:center  !important;
}
.progress-container.svelte-nuzrbq .container .milestone-wrap .milestones .progress-bar-rail.svelte-nuzrbq {
    height: 4px !important;
}
.progress-container.svelte-nuzrbq .container .milestone-wrap .milestones .progress-bar-rail.svelte-nuzrbq {
    top: 31px !important;
}
span.svelte-yb4nuo {
    font-weight: 700 !important;
}
.sidecart .custom-brand-banner {
    font-size: 13px !important;
}
.item {
    padding: 12px 8px !important;
}
.icon-wrap.svelte-nuzrbq {
    background:transparent !important;
}
 .milestones.svelte-nuzrbq:before {
    top: 11px;
    content: ' ' !important;
    position: absolute;
    width: 26px;
    background-size: cover;
    height: 24px;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/vecteezy_ai-generated-red-gift-box-with-golden-bow-on-transparent_37796385_2.png?v=1776423763);
    z-index: 99999;
}
.view-notes-wrapper {
    display: flex;
}
.order-note.svelte-1a1nfg5 {
    box-shadow: 0px 0px 4px 0px #00000040 !important;
    background: #fff !important;
    border-radius: 20px !important;
    text-decoration: none !important;
    padding: 5px 12px 5px 25px;
    margin: 0 !important;
    position: relative;
}

.order-note p {
    font-weight: 600 !important;
    font-size: 12px !important;
    color:#000000;
    position: relative;
}
.order-note.svelte-1a1nfg5:before {
    content: '';
    height: 16px;
    position: absolute;
    width: 16px;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Frame.svg?v=1776681731);
    left: 6px;
}
    .upSell-container.svelte-bmzzto.mb-15 {
    border: none !important;
        padding: 0 !important;
}
.title.svelte-bmzzto {
    font-family: "PT Serif", serif !important;
    font-weight: 400 !important;
    font-size: 18px !important;;
    color: #000 !important;
}  
    .card.svelte-176ttbg {
    flex-direction: column;
}

.card.svelte-176ttbg {
    max-width: 185px !important;
    border: none !important;
    padding: 0 !important;
    flex-direction: column !important;
}
 .product-image.svelte-176ttbg.svelte-176ttbg {
    height: auto !important;
    width: 100% !important;
    border-radius: 5px !important;
    max-height: max-content !important;
}   
 p.product-name.svelte-176ttbg {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 100% !important;
        color: #000000 !important;
}   
.product-name.svelte-176ttbg.svelte-176ttbg {
    max-width: unset !important;
}
.card-right-container.svelte-176ttbg.svelte-176ttbg {
    margin-left: 0 !important;
    margin-top: 16px !important;
    gap: 2px !important;
    margin-bottom: 6px;
}
button.add-btn.svelte-176ttbg {
    color: #fff;
    font-weight: 600;
    border: none !important;
    background: #9B5E34 !important;
    border-radius: 20px !important;
    padding: 4px 13px 9px;
    text-transform: uppercase;
}
p.price.svelte-176ttbg {
    width: calc(100% - 74px);
    max-width: none !important;
    flex-direction: row-reverse;
    display: flex !important;
    align-items: center;
    gap: 2px;
    justify-content: space-between;
}
strike.svelte-176ttbg {
    color: #3D3D3D !important;
    font-size: 10px !important;
}   
 p.price.svelte-176ttbg span {
    font-weight: 800 !important;
    font-size: 16px !important;
     color: #000000 !important;
}     
 .scroll-container.svelte-bmzzto {
    scrollbar-width: thin !important;
} 
    .discount-banner.svelte-176ttbg {
    display: none !important;
}  
 .custom-price-text h3 {
    font-family: "PT Serif", serif !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    color: #000 !important;
}   
    strike.svelte-176ttbg {
    position: relative;
    top: 1px;
} 
.item .quantity-handler-wrapper {
       margin-left: 0 !important;
    margin-bottom: 0 !important;
}    
span.final-price {
    order: 1!important;
}    
span.discount-percentage {
    order: 3 !important;
}    
 .item .variant-list {
    margin-top: -4px !important;
    order: 4 !important;
}   
 .variant-list {
    order: 5 !important;
} 
    select {
    background: #F1F0F0 !important;
    border: 0 !important;
}  
.item .quantity-handler {
    background: #fff !important;
    border: 1px solid #B6B6B6 !important;
    border-radius: 10px !important;
    padding: 0px 7px !important;
}
.item .quantity-handler span, .item .quantity-handler input.item-quantity {
    border-right: none !important;
    border-left:none !important;
    padding: 0 !important;
     color: #9B5E34 !important;
}  
 .item .quantity-handler input.item-quantity {
    font-weight: 700 !important;
    font-size: 14px !important;
}   
 .item .quantity-handler {
    font-size: 17px !important;

}   
.product-tile-wrapper span.review-icon {
    line-height: 0 !important;
    border-left: 1px solid #85858566 !important;
    padding-left: 5px !important;
}  
 select {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important ;

} 
      span.variant-selector{
            position: relative  !important;
      }
span.variant-selector::after {
    content: "";
    position: absolute;
    right: 3px;
    top: 59%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/expand_more.svg?v=1776753969) no-repeat center;
    background-size: contain;
    pointer-events: none;
}  
.side-cart-content-wrapper .variant-selector select {
        padding: 3.5px 5px !important;
    padding-right: 16px !important;
    font-weight: 700 !important;
    font-size: 10px !important;

}

.remove-btn svg {
    fill: #fff !important;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-image: url('https://cdn.shopify.com/s/files/1/0034/7901/1441/files/image_103_f9b698fa-c23b-4a4f-8f44-74ca7882159f.png?v=1776762529');
}
.remove-btn svg path{
   opacity: 0 !important;
}
    .product-tile-wrapper.false {
    position: relative !important;
}
.remove-btn {
    position: absolute !important;
    right: 15px !important;
    bottom: 6px !important;
}
.top-section  .img img {
    height: auto !important;
}  
.top-section .img {
    height: auto !important;
} 
 .item-price .product-main-content {
position:relative;
    }
.item-price .quantity-handler {
   position:absolute;
   left:112px;
   bottom:14px;
}
.item-price span, .item-price strike.compare-at-price {
     display: none !important;
 }
.product-tile-wrapper.false {
    border-bottom: none;
    box-shadow: 0px 0px 4px 0px #00000040;
    margin-bottom: 16px;
    border-radius: 10px;
} 
 .custom-price-info {
   justify-content: space-between;
    display: flex;
    align-items: center;
    margin-top: 4px;
    padding-bottom: 40px !important;
    max-width: 90% !important;
}  
 .item .details .sidecart-product-title {
    line-height: 1.2;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 100%;
    font-weight: 700;
}     
.item .variant-selector select {
    padding: 2.5px 14px 2.5px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    margin-right: 5px !important;
    border: 0 !important;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/expand_more_c97e5b88-afe7-42a1-81f3-d88fb7958215.svg?v=1778148703) !important;
    background-repeat: no-repeat !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    background-position: 96% !important;
    background-color: #F1F0F0 !important;
} 
    .img img {
    width: 90px !important;
    min-width: 90px !important;
    height: auto !important;
    border-radius: 3.42px !important;

}
 .item, .img
 {
      max-height: unset !important;
    height: unset;
    line-height: 0;
}
    span.cstm-pdp-reviw-txt {
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    color:#3D3D3D;
}
    .custom-jdgm-review-flex {
    display: flex;
    align-items: center;
        gap: 4px;
}
        span.variant-price {
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    position: relative;
    top: 2px;
}
    span.compare-price {
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    text-decoration: line-through;
    color: #999999;
    position: relative;
    top: 0;
}
span.discount-badge {
    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #FE7E42;
    position: relative;
    top: 0px;
}
.item .details {
    width: calc(100% - 90px) !important;
}
.quantity-handler-wrapper svg {
    position: absolute;
   bottom: 12px;
    right: 20px;
    width: 20px;
    height: 20px;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/image_103.png?v=1778151417);
}
.quantity-handler-wrapper svg path{
   visibility: hidden !important;
}
.item .variant-list {
    margin-top: 0 !important;
}
    .item .quantity-handler {
    background: transparent !important;
    border: 1px solid #B6B6B6 !important;
    border-radius: 20px !important;
    padding: 2px 6px !important;
    font-size: 24px !important;
    line-height: 12px !important;
    color: #9B5E34 !important;
    height: 24px !important;
     display: flex;
    height: 24px !important;
    align-items: center;
}
    .item .quantity-handler span, .item .quantity-handler input.item-quantity {
    height: 17px !important;
    line-height: 1 !important;
    display: inline-block !important;
    padding: 0px 0px !important;
    text-align: center !important;
        border: 0 !important;
        min-width: unset !important;
    min-height: unset;
}
    .item .quantity-handler input.item-quantity {
    border: none !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    color: #9B5E34 !important;
    text-align: center !important;
    padding: 0px !important;
}
   .item .quantity-handler  span.increase-quantity {
   line-height: 1.1 !important;
    font-weight: 500;
}
.item .details .sidecart-product-title {
     max-width: unset !important;
    width: unset !important;
        margin-bottom: 4px;
          margin-top: 6px;
}
.item .details {
    padding: 0px 0 0 12px  !important;
}

.details .custom-jdgm-review-flex span:first-child span{
    color: #FFCA52 !important;
}
.sidecart-footer strike.svelte-yb4nuo {
    display: none !important;
}
 p.cstm-price-enclusive {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
} 
.sidecart-footer strike.svelte-mdyw6z {
    display: none;
} 
.sidecart-footer.svelte-mdyw6z .gokwik-checkout button .btn-content .btn-text .checkout-btn-subtitle.svelte-mdyw6z {
    margin: 0;
}     
 @media (max-width: 768px) {
      .item .reduce-quantity, .item .increase-quantity {
        min-width: unset !important;
    }
        .item .variant-list {
    margin-top: -1px !important;
}

}

   
@media (max-width: 446px) {
span.compare-price {
    font-size: 11px;
}
span.discount-badge {
    display: none !important;
}
  .sidecart.svelte-1nlkjzs.svelte-1nlkjzs {
    width: 95% !important;
}
.sidecart .custom-brand-banner {
    font-size: 11px !important;
}
.item .details .sidecart-product-title {
    font-size: 14px !important;
}
.item .item-price .final-price, .item-price span {
    font-size: 14px !important;
}
.my-checkout-text:after {
    height: 37px;
    width: 10px;
    right: -5px;
    background-size: cover;
    top: 0px;
}
.my-checkout-text:before {
    height: 37px;
    width: 10px;
    left: -5px;
    top: 0;
    background-size: cover;
}
.item-list-wrapper .item-price {
    flex-wrap: wrap !important;
} 
.remove-btn svg {
    width: 16px;
    height: 16px;
}     
.remove-btn {
    bottom: 11px !important;
}  
 .img img {
    width: 70px !important;
    min-width: 70px !important;
}  
.item .details {
    width: calc(100% - 70px) !important;
} 
 span.cstm-item-stars {
    gap: 2px !important;
}  
.item .details {
    padding: 0px 0 0 10px !important;
}   
.quantity-handler-wrapper svg {
    bottom: 8px;
}  
.my-checkout-text {
    padding: 8.5px 2px !important;
} 
        .item-price .quantity-handler {
    left: 90px;
}   
    .item .quantity-handler span {
    line-height: 1.8 !important;
}
.item .quantity-handler input.item-quantity {
    line-height: 2 !important;
}

 .item .quantity-handler span.increase-quantity {
    line-height: 1.9 !important;
}               
}
@media (max-width: 360px) {
.my-checkout-text{
    padding: 9.5px 2px !important;
    font-size: 12px;
}
}
     `;
        
        shadowRoot.appendChild(style);
        console.log("✅ CSS injected!");
    }
    
    injectCSS();
})();